import type {Components} from '@malt/joy-entrypoint';

interface SelectElement extends HTMLElement, Components.JoySelect {}

type BusinessSectorResource = {
    [k: string]: string[];
};

Hop.requireMessage('company.activity.area.*');
Hop.requireMessage('company.activity.sector.*');

Hop.defineModule('signup-confirm-activity-sector', (root, params: {industriesSector: BusinessSectorResource}) => {
    const industriesBySector = params.industriesSector;

    const businessSectorSelectElement = root.querySelector('#confirm-signup-activity-sector-input') as SelectElement;
    const businessIndustrySection = root.querySelector('.js-confirm-modale-signup-section__industry') as SelectElement;

    function generateIndustryOptions(selectElement: SelectElement) {
        const selectedSector = businessSectorSelectElement.value as string | undefined;
        let output = '<option disabled selected>-</option>';

        if (!selectedSector) {
            selectElement.setAttribute('disabled', 'true');
        } else {
            const activityIndustries = industriesBySector[selectedSector];

            activityIndustries?.forEach((industry: string) => {
                output += `<option value="${industry}">${Hop.message('company.activity.area.' + industry)}</option>`;
            });
        }
        selectElement.innerHTML = output;
    }

    function refreshBusinessIndustrySelect() {
        root.querySelector('#confirm-signup-activity-industry-input')?.remove();
        const newJoySelect = document.createElement('joy-select');
        Object.assign(newJoySelect, {
            id: 'confirm-signup-activity-industry-input',
            name: 'businessIndustry',
            required: true,
            label: Hop.message('confirm.signup.modal.client.form.business.industry'),
            optionalLabel: Hop.message('generic.form.optional.mention'),
        });
        generateIndustryOptions(newJoySelect);
        businessIndustrySection?.appendChild(newJoySelect);
    }

    function init() {
        businessSectorSelectElement.addEventListener('change', refreshBusinessIndustrySelect);
    }

    init();

    return function destroy() {
        businessSectorSelectElement.removeEventListener('change', refreshBusinessIndustrySelect);
    };
});
